import {createSlice} from '@reduxjs/toolkit';
const initialData = {
  searchData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'search',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchTheSearchDataStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchSearchData: (state, action) => {
      state.searchData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

export const {fetchSearchData, fetchTheSearchDataStart, fetchError} = slice.actions;
